/* ===========================================================================
   Shady Co — variant picker
   ---------------------------------------------------------------------------
   Matches the selected option values against the product's variant list and
   updates the hidden variant ID, the price, the button state, the gallery and
   the URL. Nothing here scrapes rendered text; it reads the JSON that
   main-product.liquid prints, so money formats and locales stay correct.
   =========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return format
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', whole.replace(/,/g, ' ') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', whole.replace(/,/g, ' '));
  }

  function init() {
    var picker = document.querySelector('[data-variant-picker]');
    var dataTag = document.querySelector('[data-variant-data]');
    if (!picker || !dataTag || picker.dataset.bound === 'true') return;
    picker.dataset.bound = 'true';

    var variants;
    try {
      variants = JSON.parse(dataTag.textContent);
    } catch (e) {
      return;
    }

    var idInput = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-price]');
    var button = document.querySelector('[data-add-button]');
    var gallery = document.querySelector('[data-gallery]');
    var strings = (window.theme && window.theme.strings) || {};

    function selectedOptions() {
      return Array.prototype.map.call(
        picker.querySelectorAll('input[type="radio"]:checked'),
        function (input) { return input.value; }
      );
    }

    function matchVariant(options) {
      return variants.find(function (variant) {
        return options.every(function (value, index) { return variant.options[index] === value; });
      });
    }

    function update() {
      var variant = matchVariant(selectedOptions());

      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = strings.unavailable || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = '<span class="font-body-lg text-body-lg text-night">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="font-body-sm text-body-sm text-on-surface-variant ml-3">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }

      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? (strings.addToCart || 'Add to cart')
          : (strings.soldOut || 'Sold out');
      }

      if (gallery && variant.featured_image && typeof variant.featured_image.position === 'number') {
        gallery.dispatchEvent(new CustomEvent('gallery:show', {
          detail: { index: variant.featured_image.position - 1 },
        }));
      }

      // Keep the URL shareable and the back button meaningful.
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    picker.addEventListener('change', update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
